// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorContainer_container__TTAOs"};